<nav
	*ngIf="visible"
	class="app-mobile-tab-bar"
	[style.--mobile-tab-count]="tabs.length"
	aria-label="Navigation principale">
	<button
		*ngFor="let tab of tabs"
		type="button"
		class="app-mobile-tab-bar__item"
		[class.app-mobile-tab-bar__item--active]="isActive(tab)"
		[attr.aria-current]="isActive(tab) ? 'page' : null"
		(click)="navigate(tab); $event.stopPropagation()">
		<i class="pi" [ngClass]="tab.icon" aria-hidden="true"></i>
		<span>{{ tab.label | translate }}</span>
	</button>
</nav>
